// detail-widget-registry.js
import ToggleDetail1Widget from "./widget/toggle-detail-1";
import MultiSelectDetail1Widget from "./widget/multi-select-detail-1";
import TextDetail1Widget from "./widget/text-detail-1";
import TimeDetail1Widget from "./widget/time-detail-1";
import DateDetail1Widget from "./widget/date-detail-1";
import DateTimeDetail1Widget from "./widget/date-time-detail-1";
import BrightnessDetail1Widget from "./twin-widget/brightness-detail-1";
import ColorDetail1Widget from "./twin-widget/color-detail-1";
import OnOffBrightnessColorDetail1Widget from "./twin-widget/onoff-brightness-color-detail-1";
import OnOffDetail1Widget from "./twin-widget/onoff-detail-1";
import MotionDetail1Widget from "./twin-widget/motion-detail-1";
import PresentDetail1Widget from "./twin-widget/present-detail-1";
import OnlineDetail1Widget from "./twin-widget/online-detail-1";
import ButtonPressDetail1Widget from "./twin-widget/buttonPress-detail-1";
import ContactSensorDetail1Widget from "./twin-widget/contact-sensor-detail-1";
import TemperatureDetail1Widget from "./twin-widget/temperature-detail-1";
import HumidityDetail1Widget from "./twin-widget/humidity-detail-1";
import IlluminanceDetail1Widget from "./twin-widget/illuminance-detail-1";
import VolumeMuteDetail1Widget from "./twin-widget/volume-mute-detail-1";
import MediaPlaybackDetail1Widget from "./twin-widget/media-playback-detail-1";
import WindowOpenCloseDetail1Widget from "./twin-widget/window-open-close-detail-1";
import LockDetail1Widget from "./twin-widget/lock-detail-1";
import FanDetail1Widget from "./twin-widget/fan-detail-1";
import Thermostat1Widget from "./twin-widget/thermostat-1";
import NumberDetail1Widget from "./widget/number-detail-1";
import NumberUnitDetail1Widget from "./widget/number-unit-detail-1";
import SelectDetail1Widget from "./widget/select-detail-1";
import BrightnessNumberDetail1Widget from "./tag/brightness-number-detail-1";
import ColorTempNumberDetail1Widget from "./tag/colorTemp-number-detail-1";
import AutomationTitleDetail1Widget from "./widget/automation-title-detail-1";
import DynamicWidgetRenderer from "./widget/dynamic-widget-render";
import DefaultDetail1Widget from "./default/default-detail-1";

const detailWidgetMap = new Map();

// Register detail widgets for detail dialog view
export const registerDetailWidgets = () => {
  detailWidgetMap.set("default.toggle", ToggleDetail1Widget);
  detailWidgetMap.set("default.bool", ToggleDetail1Widget);
  detailWidgetMap.set("default.number", NumberDetail1Widget);
  detailWidgetMap.set("default.select", SelectDetail1Widget);
  detailWidgetMap.set("default.multiSelect", MultiSelectDetail1Widget);
  detailWidgetMap.set("default.select[]", MultiSelectDetail1Widget);
  detailWidgetMap.set("default.text", TextDetail1Widget);
  detailWidgetMap.set("default.string", TextDetail1Widget);
  detailWidgetMap.set("default.timeGeneral", TimeDetail1Widget);
  detailWidgetMap.set("default.dateGeneral", DateDetail1Widget);
  detailWidgetMap.set("default.timestamp", DateTimeDetail1Widget);

  // twin
  detailWidgetMap.set(
    "default.basic.device.onoff_brightness_color",
    OnOffBrightnessColorDetail1Widget
  );
  detailWidgetMap.set(
    "default.basic.device.brightness",
    BrightnessDetail1Widget
  );
  detailWidgetMap.set("default.basic.device.color", ColorDetail1Widget);
  detailWidgetMap.set("default.basic.device.onoff", OnOffDetail1Widget);
  detailWidgetMap.set("default.basic.device.motion", MotionDetail1Widget);
  detailWidgetMap.set("default.basic.device.presence", PresentDetail1Widget);
  detailWidgetMap.set("default.basic.device.online", OnlineDetail1Widget);
  detailWidgetMap.set(
    "default.basic.device.buttonPress",
    ButtonPressDetail1Widget
  );
  detailWidgetMap.set(
    "default.basic.device.contactsensor",
    ContactSensorDetail1Widget
  );
  detailWidgetMap.set(
    "default.basic.device.temperature",
    TemperatureDetail1Widget
  );
  detailWidgetMap.set("default.basic.device.humidity", HumidityDetail1Widget);
  detailWidgetMap.set(
    "default.basic.device.illuminance",
    IlluminanceDetail1Widget
  );
  detailWidgetMap.set(
    "default.basic.device.audioVolumeMute",
    VolumeMuteDetail1Widget
  );
  detailWidgetMap.set(
    "default.basic.device.mediaPlayback",
    MediaPlaybackDetail1Widget
  );
  detailWidgetMap.set(
    "default.basic.device.windowopenclose",
    WindowOpenCloseDetail1Widget
  );
  detailWidgetMap.set("default.basic.device.lockUnlock", LockDetail1Widget);
  detailWidgetMap.set("default.basic.device.fan", FanDetail1Widget);
  detailWidgetMap.set("default.basic.device.thermostat", Thermostat1Widget);
  detailWidgetMap.set("default.numberUnit", NumberUnitDetail1Widget);
  detailWidgetMap.set("default.duration", NumberUnitDetail1Widget);
  detailWidgetMap.set("default.temperature", NumberUnitDetail1Widget);
  detailWidgetMap.set("default.temperaturediff", NumberUnitDetail1Widget);
  detailWidgetMap.set("default.weight", NumberUnitDetail1Widget);
  detailWidgetMap.set("default.length", NumberUnitDetail1Widget);

  // tag
  detailWidgetMap.set(
    "default.brightness:number",
    BrightnessNumberDetail1Widget
  );
  detailWidgetMap.set(
    "default.colorTemperature:number",
    ColorTempNumberDetail1Widget
  );

  // automation
  detailWidgetMap.set("default.automationtitle", AutomationTitleDetail1Widget);
};

// Function to register custom detail widgets
export const registerDetailWidget = (skinName, WidgetComponent) => {
  detailWidgetMap.set(skinName, WidgetComponent);
};

// Function to get detail widget component
export const getDetailWidgetComponent = (skin, componentCode) => {
  if (componentCode) {
    const DynamicWidgetComponent = (props) => (
      <DynamicWidgetRenderer code={componentCode} {...props} />
    );
    DynamicWidgetComponent.displayName = "DynamicDetailWidgetComponent";
    return DynamicWidgetComponent;
  }
  const widgetComponent = detailWidgetMap.get(skin);

  if (!widgetComponent) {
    return DefaultDetail1Widget;
  }
  return widgetComponent;
};
